<div class="flex flex-col gap-4">
  <div *ngIf="summaryReview$ | async as summary"
       class="h4-text text-text-primary" i18n>Reviews: {{summary.reviewCount}}</div>
  <div *ngIf="pagedReviews as personReviews; else loading">
    <ul>
      <li *ngFor="let review of personReviews" class="bg-background-primary rounded-2xl shadow-md mb-4 p-6 flex flex-col gap-4">
        <div class="flex flex-row">
          <img *ngFor="let ratingId of fiveStars; index as i"
            src="{{showIcon(i, review.rating)}}" class="h-5 w-5" alt="star"/>
        </div>
        <div class="body-m-text text-text-secondary border-b pb-4">
          {{review.comment}}
        </div>
        <div class="flex flex-row justify-between body-s-text text-text-primary">
          <div class="flex flex-row">
            <div class="flex items-center"
                 [ngClass]="review.avatarLoaded && review.avatarUrl == null ? 'flex-col md:flex-row' : 'flex-row'">
              <div *ngIf="!review.avatarLoaded" class="min-w-10 w-10 h-10"></div>
              <img *ngIf="review.avatarLoaded && review.avatarUrl != null" [src]="review.avatarUrl" alt="Profile picture"
                   class="object-cover rounded-full min-w-10 w-10 h-10"/>
              <div *ngIf="review.avatarLoaded && review.avatarUrl == null" >
                <img src="/assets/icons/dark/profile.svg" class="h-10 w-10" alt=""/>
              </div>
            </div>
            <div class="flex flex-col ml-2">
              <span class="body-s-text-bold text-text-primary">
                {{review.reviewAuthorName}}
              </span>
              <span class="body-xs-text text-text-primary">
                {{review.reviewAuthorName}}
              </span>
            </div>
          </div>
          <span class="body-s-text text-text-primary">
            {{review.createdAt | date:'MMMM d, y'}}
          </span>
        </div>
      </li>
    </ul>
    <div *ngIf="loadMore" class="flex flex-col items-center py-4">
      <button type="button" (click)="loadMoreReviews()"
        class="secondary-button w-64"
        i18n>Load more</button>
    </div>
  </div>
  <ng-template #loading>
    <div class="w-full h-full flex justify-center items-center">
      <mat-spinner></mat-spinner>
    </div>
  </ng-template>
</div>
